import { Model, Collection } from 'vue-mc';
import moment from 'moment';
import globalConfig from '@/core/config/app';
import Translator from 'bazinga-translator';
import SystemService from '@/core/services/system.service';
// Validation rules
import {
  boolean,
  equal,
  integer,
  min,
  required,
  string,
} from 'vue-mc-validation';

class Notification extends Model {

  constructor(data) {
    super(data);
    this.init();
  }

  // Default attributes that define the "empty" state.
  defaults() {
    return {
      id: '',
      type: '',
      title: '',
      body: '',
      data: {},
      timestamp: '',
      user_hashid: '',
      is_read: false
    };
  }

  // Attribute mutations.
  mutations() {
    return {
      id: String,
      title: String,
      type: String,
      timestamp: (val) => {
        if (val) {
          return val;

        }
      }
    };
  }

  // Attribute validation
  validation() {
    return {
      id: string.and(required),
      title: string.and(required),
      type: string.and(required),
    };
  }

  // // Route configuration
  // routes() {
  //   return {
  //     fetch: '/task/{id}',
  //     save:  '/task',
  //   }
  // }

  init() {
    this.on('change', function (options) {
      switch (options.attribute) {
        case 'code':
          //console.log(options.previous + ' => ' + options.value);
          break;
      }
    });
  }

  getUrl() {
    if (SystemService.isWebContext() && this.data['web.path']) {
      return this.data['web.path'];
    }
    if (this.data['app.route']) {
      return window.JsRouting.generate(this.data['app.route'], this.data['app.route.params'] || {});
    }
    return window.location.href;
  }
}

export default Notification;
